import { render } from "./QRCodeValidate.vue?vue&type=template&id=8f2fb59c&scoped=true&ts=true"
import script from "./QRCodeValidate.vue?vue&type=script&lang=ts"
export * from "./QRCodeValidate.vue?vue&type=script&lang=ts"

import "./QRCodeValidate.vue?vue&type=style&index=0&id=8f2fb59c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f2fb59c"]])

export default __exports__